import React from "react";
import { BookOpenIcon } from "@heroicons/react/solid";
import { certificate } from "../data";

export default function Certificate() {
  return (
    <section id="certificate" className="text-gray-400 bg-gray-900 body-font">
      <div className="container px-5 py-10 mx-auto text-center lg:px-40">
        <div className="flex flex-col w-full mb-20">
          <BookOpenIcon className="mx-auto inline-block w-10 mb-4" />
          <h1 className="sm:text-4xl text-3xl font-medium title-font mb-4 text-white">
            My Certificate
          </h1>
        </div>
        <div className="flex flex-wrap -m-4">
          {certificate.map((certificate) => (
            <a
              key={certificate.image}
              className="sm px-2 py-8">
              <div className="flex relative">
                <img
                  alt="gallery"
                  className="object-contain h-48 w-96"
                  src={certificate.image}
                />
                
              </div>
              <h2>{certificate.title}</h2>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}


// WEBPACK FOOTER //
// ./src/components/Certificate.js